import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../utils/Loader';
import { setStatFilters, resetStatFilters, fetchPromocodeStat, fetchPromotionsStat } from '../../action/statistics';
import { fetchCities } from '../../action/handbook';
import Select from 'react-select';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import swal from 'sweetalert';
import { utils, writeFileXLSX } from 'xlsx';
import { roleId } from '../../constants/app';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
}

function compare( a, b ) {
    if ( a.value < b.value ){
      return 1;
    }
    if ( a.value > b.value ){
      return -1;
    }
    return 0;
  }

class Promocode extends Component {
    componentDidMount() {
       this.props.fetchCities();
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props.promocode;
        const updated = {
            ...filters,
            [field]: data
        }
        this.props.setStatFilters('promocode', updated);
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.promocode;

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {
            updated.createdEndDate = moment(date).add({ days: 30 }).toDate()
        }

        this.props.setStatFilters('promocode', updated);
    }

    onDownloadPromocodeStat = () => {
        this.props.fetchPromocodeStat()
        .then((res) => {
            if(!res || res.length === 0) {
                swal({
                    title: "Данные отсутствуют",
                    text: "Выберите другие фильтры",
                    icon: "warning",
                    dangerMode: true,
                })
                return;
            }

            if(!!res) {
                const promocodes = res.sort(compare).map(item => {
                    return {
                        'Промокод': item.name ? item.name : '-',
                        'Общее кол-во использований': item.value ? item.value : '-',
                        'Общая сумма (руб.) заказов с промокодом': item.totalSum ? item.totalSum : '-',
                        'Кол-во заказов на доставку с промокодом': item.delivery ? item.delivery : '-',
                        'Сумма (руб.) заказов на доставку с промокодом': item.deliverySum ? item.deliverySum : '-',
                        'Кол-во заказов на вынос с акцией': item.own ? item.own : '-',
                        'Сумма (руб.) заказов на вынос с промокодом': item.ownSum ? item.ownSum : '-',
                        'Кол-во заказов с сайта с промокодом': item.site ? item.site : '-',
                        'Сумма (руб.) заказов с сайта с промокодом': item.siteSum ? item.siteSum : '-',
                        'Кол-во заказов из приложения с промокодом': item.app ? item.app : '-',
                        'Сумма (руб.) заказов из приложения с промокодом': item.appSum ? item.appSum : '-',
                        'Кол-во заказов от КЦ с акцией': item.cc ? item.cc : '-',
                        'Сумма (руб.) заказов от КЦ с промокодом': item.ccSum ? item.ccSum : '-',
                        'Кол-во заказов оформленных на филиале с промокодом': item.point ? item.point : '-',
                        'Сумма (руб.) заказов оформленных на филиале с промокодом': item.pointSum ? item.pointSum : '-',
                        'Кол-во заказов оформленных через CRM от непривязанных к КЦ и филиалу ролей с промокодом': item.otherCrm ? item.otherCrm : '-',
                        'Сумма (руб.) заказов оформленных через CRM от непривязанных к КЦ и филиалу ролей с промокодом': item.otherCrmSum ? item.otherCrmSum : '-',
                    }
                })
                const ws = utils.json_to_sheet(promocodes);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Data");
                writeFileXLSX(wb, "PromocodeStat.xlsx");
            }
        });
    }

    onDownloadPromotionsStat = () => {
        this.props.fetchPromotionsStat()
        .then((res) => {
            if(!res || res.length === 0) {
                swal({
                    title: "Данные отсутствуют",
                    text: "Выберите другие фильтры",
                    icon: "warning",
                    dangerMode: true,
                })
                return;
            }

            if(!!res) {
                const promotions = res.sort(compare).map(item => {
                    return {
                        'Акция': item.name ? item.name : '-',
                        'Общее кол-во использований': item.value ? item.value : '-',
                        'Общая сумма (руб.) заказов с акцией': item.totalSum ? item.totalSum : '-',
                        'Кол-во заказов на доставку с акцией': item.delivery ? item.delivery : '-',
                        'Сумма (руб.) заказов на доставку с акцией': item.deliverySum ? item.deliverySum : '-',
                        'Кол-во заказов на вынос с акцией': item.own ? item.own : '-',
                        'Сумма (руб.) заказов на вынос с акцией': item.ownSum ? item.ownSum : '-',
                        'Кол-во заказов с сайта с акцией': item.site ? item.site : '-',
                        'Сумма (руб.) заказов с сайта с акцией': item.siteSum ? item.siteSum : '-',
                        'Кол-во заказов из приложения с акцией': item.app ? item.app : '-',
                        'Сумма (руб.) заказов из приложения с акцией': item.appSum ? item.appSum : '-',
                        'Кол-во заказов от КЦ с акцией': item.cc ? item.cc : '-',
                        'Сумма (руб.) заказов от КЦ с акцией': item.ccSum ? item.ccSum : '-',
                        'Кол-во заказов оформленных на филиале с акцией': item.point ? item.point : '-',
                        'Сумма (руб.) заказов оформленных на филиале с акцией': item.pointSum ? item.pointSum : '-',
                        'Кол-во заказов оформленных через CRM от непривязанных к КЦ и филиалу ролей с промокодом': item.otherCrm ? item.otherCrm : '-',
                        'Сумма (руб.) заказов оформленных через CRM от непривязанных к КЦ и филиалу ролей с промокодом': item.otherCrmSum ? item.otherCrmSum : '-',
                    }
                })
                const ws = utils.json_to_sheet(promotions);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Data");
                writeFileXLSX(wb, "PromotionsStat.xlsx");
            }
        });
    }

    getOptionsSelectCity() {
        const { user, cities } = this.props;
        let options = [];

        if (user.allPoints || user.role.id === roleId.admin) options.push({value: 'all', label: 'Все города'});
        cities.forEach(item => {
            options.push({value: item.id, label: item.name})
        });

        return options;
    }

    renderHead() {
        const { promocode } = this.props
        const { loading, filters } = promocode;

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Маркетинг
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar"  style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div className="dateBlock">
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата от"
                            selected={filters.createdStartDate}
                            onChange={this.onChangeDateInput('createdStartDate')}
                            maxDate={moment().toDate()}
                        />
                        <div>-</div>
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата до"
                            selected={filters.createdEndDate}
                            onChange={this.onChangeDateInput('createdEndDate')}
                            maxDate={moment(filters.createdStartDate).add({ days: 30 }).toDate()}
                            required={filters.createdStartDate}
                        />
                    </div>
                    <div style={{ width: 250 }}>
                        <Select
                            isLoading={this.props.loadingCity || loading}
                            isDisabled={this.props.loadingCity || loading}
                            value={filters.city}
                            closeMenuOnSelect={true}
                            options={this.getOptionsSelectCity()}
                            onChange={this.setFilters('city')}
                            placeholder="Город"
                            noOptionsMessage={() => 'Нет городов'}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBody() {
        const { promocode } = this.props
        const { loading, filters } = promocode;

        if (!filters.city) return (
            <div className="kt-portlet">
                <div className="kt-portlet__body">Не указан город</div>
            </div>
        );

        if (loading) return <div style={styles.loading}><Loader /></div>;
        
        return(
            <>
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Промокоды - статистика
                        </h3>
                        <span className='info_statistic-label' title="Скачать файл со статистикой использования промокодов клиентами в выбранном городе за указанный период">?</span>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <div className="dateBlock" style={{ marginRight: 10 }}>
                            <button onClick={this.onDownloadPromocodeStat} className="btn btn-dark btn-icon-sm">Экспорт</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Акции - статистика
                        </h3>
                        <span className='info_statistic-label' title="Скачать файл со статистикой использования акций клиентами в выбранном городе за указанный период">?</span>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <div className="dateBlock" style={{ marginRight: 10 }}>
                            <button onClick={this.onDownloadPromotionsStat} className="btn btn-dark btn-icon-sm">Экспорт</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    render() {
        return (
            <>
                <div className="kt-portlet">
                    {this.renderHead()}
                </div>
                {this.renderBody()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return ({
        promocode: state.statistics.promocode,
        cities: state.handbook.cities,
        loadingCity: state.loaders.cities,
        user: state.user.info,
    });
};

const mapDispatchToProps = {
    fetchPromocodeStat: () => fetchPromocodeStat(),
    fetchPromotionsStat: () => fetchPromotionsStat(),
    fetchCities: () => fetchCities(true),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    resetStatFilters: (name) => resetStatFilters(name),
}

export default connect(mapStateToProps, mapDispatchToProps)(Promocode);